import React from "react";
import { Table } from "semantic-ui-react";

const PostExpandedComponent = ({ data }) => {
    // console.log(data);
    return (
        <>
            <Table.Row>
                <Table.Cell>
                    <Table basic='very' compact celled collapsing style={{ padding: 20, marginLeft: 50 }}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>#</Table.HeaderCell>
                                <Table.HeaderCell>Asset Name</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {data && data.post_asset.map((item, index) =>
                                <Table.Row key={index}>
                                    <Table.Cell>{index + 1}</Table.Cell>
                                    <Table.Cell>{item.asset.name}</Table.Cell>
                                </Table.Row>)}
                        </Table.Body>
                    </Table>
                </Table.Cell>
                <Table.Cell>
                    <Table basic='very' compact celled collapsing style={{ padding: 20, marginLeft: 50 }}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>#</Table.HeaderCell>
                                <Table.HeaderCell>Shift Name</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {data && data.post_shift.map((item, index) =>
                                <Table.Row key={index}>
                                    <Table.Cell>{index + 1}</Table.Cell>
                                    <Table.Cell>{item.shift.name}</Table.Cell>
                                </Table.Row>)}
                        </Table.Body>
                    </Table>
                </Table.Cell>
            </Table.Row>
        </>
    )
}

export default PostExpandedComponent